import React, { useState } from "react";
import axios from "axios";

function BrandDelivery() {
  const [brandName, setBrandName] = useState("");
  const [delivery, setDelivery] = useState({
    isFree: true,
    fee: 0,
    currency: "usd",
    method: "standard",
    label: "Free delivery",
    estimatedDaysMin: 5,
    estimatedDaysMax: 14,
    countries: "ALL",
  });

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setDelivery((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleGetDelivery = async () => {
    try {
      const res = await axios.get(
        `https://api.malidag.com/api/brands/delivery/${encodeURIComponent(
  brandName
)}`
      );

      const data = res.data.delivery;

      setDelivery({
        isFree: data?.isFree ?? true,
        fee: data?.fee ?? 0,
        currency: data?.currency ?? "usd",
        method: data?.method ?? "standard",
        label: data?.label ?? "Free delivery",
        estimatedDaysMin: data?.estimatedDaysMin ?? 5,
        estimatedDaysMax: data?.estimatedDaysMax ?? 14,
        countries: Array.isArray(data?.countries)
          ? data.countries.join(",")
          : "ALL",
      });

      setMessage("Delivery info loaded.");
    } catch (error) {
      setMessage(error.response?.data?.error || "Failed to get delivery info.");
    }
  };

  const handleSaveDelivery = async () => {
    try {
      const payload = {
        ...delivery,
        fee: Number(delivery.fee || 0),
        estimatedDaysMin: Number(delivery.estimatedDaysMin || 5),
        estimatedDaysMax: Number(delivery.estimatedDaysMax || 14),
        countries: delivery.countries
          .split(",")
          .map((x) => x.trim())
          .filter(Boolean),
      };

      const res = await axios.post(
        `https://api.malidag.com/api/brands/delivery/${encodeURIComponent(
        brandName
        )}`,
        payload
      );

      setMessage(res.data.message || "Delivery info saved.");
    } catch (error) {
      setMessage(error.response?.data?.error || "Failed to save delivery info.");
    }
  };

  return (
    <div className="dashboard-page">
      <div className="dashboard-container">
        <section className="dashboard-section">
          <div className="section-title">
            <h2>Add / Modify Brand Delivery</h2>
            <p>Set delivery rules per brand. For now, default is free delivery.</p>
          </div>

          <div className="card">
            <input
              type="text"
              placeholder="Brand name, e.g. jackjones"
              value={brandName}
              onChange={(e) => setBrandName(e.target.value)}
            />

            <label>
              <input
                type="checkbox"
                name="isFree"
                checked={delivery.isFree}
                onChange={handleChange}
              />
              Free delivery
            </label>

            <input
              type="number"
              name="fee"
              placeholder="Delivery fee"
              value={delivery.fee}
              onChange={handleChange}
              disabled={delivery.isFree}
            />

            <input
              type="text"
              name="currency"
              placeholder="Currency"
              value={delivery.currency}
              onChange={handleChange}
            />

            <input
              type="text"
              name="method"
              placeholder="Method"
              value={delivery.method}
              onChange={handleChange}
            />

            <input
              type="text"
              name="label"
              placeholder="Label"
              value={delivery.label}
              onChange={handleChange}
            />

            <input
              type="number"
              name="estimatedDaysMin"
              placeholder="Min delivery days"
              value={delivery.estimatedDaysMin}
              onChange={handleChange}
            />

            <input
              type="number"
              name="estimatedDaysMax"
              placeholder="Max delivery days"
              value={delivery.estimatedDaysMax}
              onChange={handleChange}
            />

            <input
              type="text"
              name="countries"
              placeholder="Countries: ALL or FR,US,GB"
              value={delivery.countries}
              onChange={handleChange}
            />

            <div className="header-actions">
              <button className="secondary-btn" onClick={handleGetDelivery}>
                Get Delivery Info
              </button>

              <button className="primary-btn" onClick={handleSaveDelivery}>
                Save Delivery Info
              </button>
            </div>

            {message && <p>{message}</p>}
          </div>
        </section>
      </div>
    </div>
  );
}

export default BrandDelivery;